import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.544 13a8 8 0 0 0-7.49 5.191l-.04.107A2 2 0 0 0 3.885 21H6a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a2 2 0 0 0 2 2h2.114a2 2 0 0 0 1.873-2.702l-.04-.107A8 8 0 0 0 14.457 13z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.293 3.293a1 1 0 0 1 1.414 0L12 5.586l2.293-2.293a1 1 0 1 1 1.414 1.414L13.414 7l2.293 2.293a1 1 0 0 1-1.414 1.414L12 8.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 7 8.293 4.707a1 1 0 0 1 0-1.414",
      clipRule: "evenodd"
    }
  )
);
var SvgMissedInboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MissedInboundFilled_default = SvgMissedInboundFilled;

export { MissedInboundFilled_default as default };
